class StickyAddCart extends HTMLElement {
  constructor() {
    super();

    this.options = this.querySelectorAll('.sticky-add-cart__option');
    this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    this.sellingPlanId = this.sellingPlanInput?.value;
    this.buttonText = this.querySelector('button.product-form__submit > span');
    this.originalSubmitButton = document.querySelector('.product-information__buy-buttons');
    this.productSectionWrapper = document.querySelector('#landing-product');
    this.stickyAddToCartAnchor = this.querySelector('.sticky-add-cart__anchor');
    this.nestedSubscriptionItem = document.querySelector('.sticky-add-cart__option[has-nested-product]');
    this.connectedElementSelector = this.dataset.connectedSelector;
    this.hideWhenSelectorVisible = this.dataset.hideWhenSelectorVisible;
    this.hideWhenSelectorVisibleMobileOnly = this.dataset.hideWhenSelectorVisibleMobileOnly === 'true';
    this.hiddenObserverState = new Map();

    this.connectedElement = document.querySelector(this.connectedElementSelector);
  }

  connectedCallback() {
    if(this.nestedSubscriptionItem) this.checkNestedProductFromSubscription()

    this.options.forEach(option => {
      option.addEventListener('click', () => {
        if (option.dataset.value == 'one-time') {
          this.sellingPlanInput?.setAttribute('disabled', true);
          if (this.buttonText) this.buttonText.innerHTML = this.dataset.onetimeButtonText;
        } else {
          this.sellingPlanInput?.removeAttribute('disabled');
          if (this.buttonText) this.buttonText.innerHTML = this.dataset.subscribeButtonText;
        }
      })
    })

    this.stickyAddToCartAnchor?.addEventListener('click', () => {
      const productFormButtonSubmit = document.querySelector('.product-form__buttons button[type="submit"]')
      if (productFormButtonSubmit) productFormButtonSubmit.click();
    })

    const updateVisibility = () => {
      const shouldHide = [...this.hiddenObserverState.entries()].some(([element, isVisible]) => {
        if (!isVisible) return false;

        const isMobileOnlyTarget =
          element === this.hideWhenElement && this.hideWhenSelectorVisibleMobileOnly;

        return !isMobileOnlyTarget || window.innerWidth < 750;
      });

      if (shouldHide) {
        return this.classList.add('sticky-add-cart--hidden');
      }

      const scrolledPast = this.connectedElement ? this.connectedElementScrolledPast : true;
      this.classList.toggle('sticky-add-cart--hidden', !scrolledPast);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          this.hiddenObserverState.set(entry.target, entry.isIntersecting);
        });
        updateVisibility();
      },
      {
        root: null,
        threshold: 0.1
      }
    );

    if (this.productSectionWrapper) observer.observe(this.productSectionWrapper);

    if (this.hideWhenSelectorVisible) {
      this.hideWhenElement = document.querySelector(this.hideWhenSelectorVisible);
      if (this.hideWhenElement) observer.observe(this.hideWhenElement);
    }

    window.addEventListener('resize', updateVisibility);

    this.connectedElementScrolledPast = false;
    
    if (this.connectedElement) {
      const connectedElementObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            this.connectedElementScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          });
          updateVisibility();
        },
        {
          root: null,
          threshold: 0
        }
      );

      connectedElementObserver.observe(this.connectedElement);
    }

    updateVisibility();
  }

  checkNestedProductFromSubscription() {
      const subscriptionWidget = document.querySelector('.sticky-add-cart__form-container')
      if (!subscriptionWidget) return

      const variantInputId = this.querySelector('input[name="id"]')
      const nestedVariantInputs = [...this.querySelectorAll('.nested-variant-id')]
      const sellingPlan = document.querySelector('.sticky-add-cart__form-container input[name*="selling_plan"]')
      if (!nestedVariantInputs.length || !sellingPlan) return

      const toggleInputs = () => {
        if (this.querySelector('input[has-nested-product]').checked) {
          variantInputId.name = 'items[0][id]'
          nestedVariantInputs.forEach((nestedInput) => nestedInput.disabled = false)
          sellingPlan.name = 'items[0][selling_plan]'
        } else {
          variantInputId.name = 'id'
          variantInputId.disabled = false
          nestedVariantInputs.forEach((nestedInput) => nestedInput.disabled = true)
          sellingPlan.name = 'selling_plan'
        }
      }

      toggleInputs()

      subscriptionWidget.addEventListener('change', () => {
        toggleInputs()
      })
  }
}

if(!customElements.get('sticky-add-cart')) {
  customElements.define('sticky-add-cart', StickyAddCart);
}
